import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import './../styles/styles.css';
import logo from "../assets/logo-titre-bdx.png";
import { useAuth } from '../context/AuthContext'; // Import du contexte Auth

// Supprimez le composant CheckoutForm, ou intégrez sa logique dans SignupStep2

function SignupStep2() {
  const API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth(); // Utilisation du hook `login` du contexte Auth

  const [email, setEmail] = useState(location.state?.email || '');
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [loading, setLoading] = useState(false); // Ajout d'un état pour le chargement

  const canSubmit = email && password && firstName && lastName;

  // Nouvelle fonction pour gérer la soumission du formulaire
  const handleFormSubmit = async (e) => {
    e.preventDefault(); // Empêche le rechargement de la page par défaut

    if (!canSubmit || loading) {
      return;
    }

    setLoading(true);

    try {
      // 1. Créer l'utilisateur
      const registerRes = await fetch(`${API_URL}/auth/register.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, firstName, lastName }),
      });
      const registerData = await registerRes.json();
      if (!registerData.success) {
        alert('Erreur inscription');
        setLoading(false);
        return;
      }
      const userId = registerData.userId;

      // 2. Créer le client Stripe
      const customerRes = await fetch(`${API_URL}/users/create-customer.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, firstName, lastName }),
      });
      const customerData = await customerRes.json();
      if (!customerData.success) {
        // En cas d'échec de la création du customer, on annule l'inscription
        await fetch(`${API_URL}/auth/delete-user.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ userId }),
        });
        // alert('Erreur création customer Stripe : ' + (customerData.message || 'Erreur inconnue'));
        setLoading(false);
        return;
      }

      // 3. Connexion de l'utilisateur
      const loginRes = await fetch(`${API_URL}/auth/login.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const loginData = await loginRes.json();
      if (loginData.success && loginData.token) {
        login(loginData.token, { userId: loginData.userId, email });
        // alert('Inscription réussie');
        navigate('/dashboard');
      } else {
        // alert('Erreur lors de la connexion automatique : ' + (loginData.message || 'Erreur inconnue'));
      }

    } catch (err) {
      // alert('Erreur : ' + err.message);
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="signup-container">
      <div className="signup-card">
        <div style={{ textAlign: 'center' }}>
          <img src={logo} alt="Gioco Mortale" className="App-logo" />
        </div>

        <h2>Créer votre compte</h2>
        
        {/* On englobe les inputs et le bouton dans une balise <form> */}
        <form onSubmit={handleFormSubmit}>
          <label className="signup-label">Adresse email*</label>
          <input
            type="email"
            className="signup-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <label className="signup-label">Mot de passe*</label>
          <input
            type="password"
            className="signup-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <div className="name-fields">
            <div className="name-input">
              <label className="signup-label">Prénom*</label>
              <input
                type="text"
                className="signup-input"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </div>
            <div className="name-input">
              <label className="signup-label">Nom*</label>
              <input
                type="text"
                className="signup-input"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>

          <p>En procédant à votre inscription, vous acceptez les <a href="/cgu">CGU</a> et les <a href="/cgv">CGV</a>.</p>

          {/* Le bouton de soumission est maintenant à l'intérieur du formulaire */}
          {canSubmit ? (
            <button type="submit" className="signup-button" disabled={loading}>
              {loading ? 'Inscription en cours...' : 'Inscription'}
            </button>
          ) : (
            <button type="button" disabled className="signup-button">
              Veuillez remplir tous les champs obligatoires
            </button>
          )}
        </form>
      </div>
    </div>
  );
}

export default SignupStep2;